<template>
    <div>

        <a href="#" @click="open()" id="add_notification" class="btn btn-link me-2 text-dark" data-bs-toggle="modal"
            data-bs-target="#messageModal">
            <i class="bi bi-bell position-relative">
                <small>
                    <span v-if="unreads"
                        class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger text-xs">
                        {{ unreads }}
                    </span>
                </small>
            </i>
        </a>

        <div class="modal fade" id="messageModal" ref="messageModal" role="dialog" aria-labelledby="toolpanel"
            aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-slideout bg-dark" role="document">
                <div class="modal-content overflow-auto rounded-0">


                    <div v-if="!loaded" class="col-12 mt-3">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                    </div>

                    <div v-if="loaded" class="bg-dark h-100">

                        <div v-if="screen == 'users'" class="col-12">
                            <div class="d-flex justify-content-between bg-black fixed-top pt-2 pb-2">
                                <a href="#" class="fw-bold text-white p-2 ps-3" @click="toggleFullScreen()">
                                    <i class="bi bi-chat text-warning"></i>
                                    Mensagens
                                </a>
                                <button @click="close()" type="button" class="btn text-white" data-bs-dismiss="modal"
                                    aria-label="Fechar">
                                    <i class="bi bi-x-lg"></i>
                                </button>
                            </div>
                            <div class="list-group rounded-0" style="margin-top:56px;">
                                <a href="#" @click="show(user.id)" v-for="(user, index) in users"
                                    class="message-list-group-item list-group-item d-flex justify-content-between cursor-pointer text-white"
                                    style="border-color: #333;">
                                    <span>{{ user.name }}</span>
                                    <span v-if="user.unread" class="text-xs">
                                        <span class="badge rounded-pill text-bg-success p-2">{{ user.unread }}</span>
                                    </span>
                                </a>
                            </div>
                        </div>

                        <div v-if="screen == 'message'">

                            <div ref="chat" id="chat"
                                class="message-chat d-flex flex-column-reverse vh-100 overflow-scroll"
                                style="padding-bottom:56px;padding-top:56px;">
                                <div class="bg-black d-flex justify-content-between fixed-top pt-2 pb-2">
                                    <button @click="main()" class="btn btn-link text-white text-decoration-none">
                                        <i class="bi bi-arrow-left me-2"></i> {{ users[showing].name }}
                                    </button>
                                    <button @click="close()" type="button" class="btn text-white"
                                        data-bs-dismiss="modal" aria-label="Fechar">
                                        <i class="bi bi-x-lg"></i>
                                    </button>
                                </div>
                                <div class="bg-message bg-dark text-white p-3">
                                    <div v-if="!users[showing].messagesLoaded" class="text-center py-4">
                                        <div class="spinner-border text-light" role="status"></div>
                                    </div>
                                    <p v-else v-for="(message, index) in users[showing].messages" class="mb-1"
                                        :class="[message.from_id == users[showing].id ? 'text-start' : 'text-end',]">
                                        <span style="display:inline-block;min-width:50px;"
                                            class="rounded ps-2 pt-1 pe-3 pb-1 position-relative"
                                            :class="[message.from_id == users[showing].id ? 'bg-yellow-500 text-dark' : 'bg-pink-600 text-white', isRead(message) ? '' : 'fw-bold',]">
                                            <span v-html="message.text" class="pb-0 pe-1 me-3"></span>
                                            <span v-if="message.hasOwnProperty('error')"
                                                class="badge bg-warning text-dark">{{ message.error }}</span>
                                            <span style="
                                                        font-size:0.6em;
                                                        position:absolute;
                                                        right:5px;
                                                        bottom:0;
                                                        opacity: 0.5;
                                                ">
                                                <span v-if="message.id">{{ message.sent_at | time }}</span>
                                                <span v-else><i class="bi bi-clock"
                                                        style="line-height: 2em;"></i></span>
                                            </span>
                                        </span>
                                    </p>
                                </div>
                                <div class="bg-black p-2 fixed-bottom">
                                    <input v-on:keyup.enter="send($event)" v-model="typing" ref="typing" type="text"
                                        data-tab="false" inputmode="text" autocomplet="off"
                                        class="form-control bg-dark text-white border-0">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const FoxTabVisibility = require('../fox/tab-visibility.js');

export default {

    props: ['user_id', 'device_id'],

    mounted() {
        FoxTabVisibility.install(this, {
            onVisible: this.onTabVisible,
            onHidden: this.onTabHidden,
        });
        if (FoxTabVisibility.isVisible()) {
            this.start();
        } else {
            this.pendingStart = true;
        }
    },

    beforeDestroy() {
        FoxTabVisibility.uninstall(this);
    },

    computed: {

    },

    data() {
        return {
            loaded: false,
            error: false,
            action: null,
            delay: 7000,
            screen: 'users', // users, message
            showing: 0,
            unreads: 0,
            lastTimestamp: 0,
            typing: '',
            users: [],
            pendingStart: false,
        };
    },

    methods: {

        onTabHidden() {
            FoxTabVisibility.clearTimer(this, 'poll');
        },

        onTabVisible() {
            if (this.pendingStart) {
                this.pendingStart = false;
                this.start();
                return;
            }
            if (this.loaded) {
                this.executeFind();
            }
        },

        errors(data) {
            if (data.hasOwnProperty('error')) {
                this.loaded = true;
                this.finding = false;
                this.error = data.error;
            }
        },

        start() {
            if (!FoxTabVisibility.isVisible()) {
                this.pendingStart = true;
                return;
            }
            let form = {
                action: 'start',
                user_id: this.user_id,
            };
            axios
                .post(`/message/user`, form)
                .then(response => (this.renderStart(response.data)))
                .catch(error => console.log(error));
        },

        executeFind() {
            if (!FoxTabVisibility.isVisible()) {
                return;
            }
            this.finding = true;
            var form = {
                action: 'find',
                user_id: this.user_id,
                timestamp: this.lastTimestamp
            };
            axios
                .post(`/message/user`, form)
                .then(response => (this.renderFind(response.data)))
                .catch(error => {
                    console.log(error);
                    this.finding = false;
                    this.scheduleFind();
                });
        },

        scheduleFind() {
            FoxTabVisibility.schedule(this, 'poll', () => this.executeFind(), this.delay);
        },

        find() {
            if (!FoxTabVisibility.isVisible()) {
                return;
            }
            this.scheduleFind();
        },

        renderFind(messages) {
            let timestamp = this.lastTimestamp;
            let ids = [];
            let beep = false;
            for (let u = 0; u < this.users.length; u++) {
                for (let m = 0; m < messages.length; m++) {

                    // lastTimestamp
                    if (timestamp < messages[m].sent_at) {
                        timestamp = messages[m].sent_at
                    }

                    // Mensagem recibida (enviada por outro usuário para mim)
                    if (messages[m].from_id == this.users[u].id) {
                        const isNew = !this.alreadyExists(messages[m]);
                        if (isNew) {
                            Vue.set(this.users[u].messages, this.users[u].messages.length, messages[m]);
                            beep = true;
                        }
                        if (this.screen == 'message' && this.users[this.showing].id == this.users[u].id && messages[m].from_id == this.users[u].id) {
                            if (!this.isRead(messages[m])) ids.push(messages[m].id);
                        } else if (messages[m].to_id == this.user_id && !this.isRead(messages[m])) {
                            this.users[u].unread = (this.users[u].unread || 0) + 1;
                        }
                    }

                    if (messages[m].to_id == this.users[u].id) {
                        // Verifica se ja existe
                        if (!this.alreadyExists(messages[m])) {
                            // Se não existe, push (Não beep e não read_at, a mensagem é minha)
                            //this.users[u].messages.unshift(messages[m]);
                            Vue.set(this.users[u].messages, this.users[u].messages.length, messages[m]);
                        }
                    }
                }
            }
            this.lastTimestamp = timestamp;
            this.updateReads();
            this.setAsRead(ids);
            this.beep(beep);
            this.finding = false;
            this.scheduleFind();
        },

        sort() {
            if (this.screen === 'message') {
                return false; // Não ordene quando o chat estiver aberto
            }

            this.users.sort((a, b) => {
                const aOrder = (a.messages && a.messages.length) ? a.messages[a.messages.length - 1].sent_at : (a.order || 0);
                const bOrder = (b.messages && b.messages.length) ? b.messages[b.messages.length - 1].sent_at : (b.order || 0);
                if (aOrder > bOrder) return -1;
                if (aOrder < bOrder) return 1;
                return 0;
            });
        },

        alreadyExists(message) {
            for (let u = 0; u < this.users.length; u++) {
                for (let m = 0; m < this.users[u].messages.length; m++) {
                    if (message.sent_at == this.users[u].messages[m].sent_at) {
                        return true;
                    }
                }
            }
            return false;
        },

        send(event) {
            // Validação
            if (!this.typing.length) {
                return false;
            }
            // Mensagem temporária
            let timestamp = new moment().unix();
            this.users[this.showing].messages.push({
                id: null,
                from_id: this.user_id,
                to_id: this.users[this.showing].id,
                text: this.typing,
                read_at: null,
                sent_at: timestamp,
                erro: false,
            });
            this.scroll();
            // Mensagem pra post
            var form = {
                action: 'send',
                text: this.typing,
                from_id: this.user_id,
                to_id: this.users[this.showing].id,
                timestamp: timestamp
            };
            axios
                .post(`/message/user`, form)
                .then(response => (this.renderSend(response.data)))
                .catch(error => console.log(error));

            this.typing = '';
        },

        renderSend(data) {
            for (let u = 0; u < this.users.length; u++) {
                for (let m = 0; m < this.users[u].messages.length; m++) {
                    if (!this.users[u].messages[m].id && this.users[u].messages[m].sent_at == data.timestamp) {
                        if (data.message) {
                            this.users[u].messages[m].id = data.message.id;
                        } else {
                            this.users[u].messages[m].error = 'Falha no envio';
                        }
                        break;
                    }
                }
            }
        },

        scroll() {
            setTimeout(() => {
                this.$refs.chat.scrollTop = this.$refs.chat.scrollHeight;
            }, 1000);
        },

        renderStart(users) {
            this.users = users;
            let maxOrder = this.lastTimestamp || 0;
            for (let u = 0; u < this.users.length; u++) {
                Vue.set(this.users[u], 'messages', this.users[u].messages || []);
                Vue.set(this.users[u], 'messagesLoaded', false);
                Vue.set(this.users[u], 'unread', this.users[u].unread ?? 0);
                Vue.set(this.users[u], 'order', this.users[u].order ?? 0);
                const o = this.users[u].order || 0;
                if (o > maxOrder) maxOrder = o;
            }
            this.lastTimestamp = maxOrder;
            this.loaded = true;
            this.updateReads();
            this.find();
        },

        loadConversation(otherId) {
            return axios
                .post(`/message/user`, { action: 'getMessages', other_id: otherId })
                .then(response => {
                    const list = response.data || [];
                    const reversed = list.slice().reverse();
                    return reversed;
                });
        },

        setAsRead(ids) {
            if (ids.length) {
                var form = {
                    action: 'setAsRead',
                    timestamp: new moment().unix(),
                    ids: ids,
                };
                axios
                    .post(`/message/user`, form)
                    .then(response => (this.renderRead(response.data)))
                    .catch(error => console.log(error));
            }
        },

        renderRead(retornos) {
            for (let i = 0; i < retornos.length; i++) {
                for (let m = 0; m < this.users[this.showing].messages.length; m++) {
                    if (retornos[i].id == this.users[this.showing].messages[m].id) {
                        this.users[this.showing].messages[m].read_at = retornos[i].read_at;
                    }
                }
            }
            this.updateReads();
        },

        /** Mensagem está lida se read_at tiver qualquer valor (não null e não vazio). */
        isRead(message) {
            const v = message && message.read_at;
            return v != null && v !== '';
        },

        updateReads() {
            let notReads = 0;
            for (let u = 0; u < this.users.length; u++) {
                const user = this.users[u];
                if (user.messagesLoaded && user.messages && user.messages.length) {
                    let notRead = 0;
                    let order = user.order || 0;
                    for (let m = 0; m < user.messages.length; m++) {
                        if (order < parseInt(user.messages[m].sent_at)) order = parseInt(user.messages[m].sent_at);
                        if (user.messages[m].to_id == this.user_id && !this.isRead(user.messages[m])) {
                            notReads++;
                            notRead++;
                        }
                    }
                    Vue.set(user, 'unread', notRead);
                    Vue.set(user, 'order', order);
                } else {
                    notReads += user.unread || 0;
                }
            }
            this.unreads = notReads;
            this.sort();
        },

        main() {
            this.screen = 'users';
        },

        updatingShowing(user_id) {
            for (let u = 0; u < this.users.length; u++) {
                if (this.users[u].id == user_id) {
                    this.showing = u;
                }
            }
        },

        setConversationAsRead(otherId) {
            const timestamp = new moment().unix();
            return axios
                .post(`/message/user`, {
                    action: 'setConversationAsRead',
                    other_id: otherId,
                    timestamp: timestamp,
                })
                .then(() => {
                    const user = this.users[this.showing];
                    if (!user) return timestamp;
                    Vue.set(user, 'unread', 0);
                    const msgs = user.messages || [];
                    for (let m = 0; m < msgs.length; m++) {
                        if (msgs[m].to_id == this.user_id) {
                            Vue.set(msgs[m], 'read_at', timestamp);
                        }
                    }
                    this.updateReads();
                    return timestamp;
                });
        },

        show(user_id) {
            this.updatingShowing(user_id);
            this.screen = 'message';

            const openChat = () => {
                this.scroll();
                setTimeout(() => {
                    if (this.$refs.typing) this.$refs.typing.focus();
                }, 500);
            };

            const afterMarkRead = () => {
                openChat();
            };

            if (this.users[this.showing].messagesLoaded) {
                this.setConversationAsRead(user_id).then(afterMarkRead).catch(err => console.log(err));
                return;
            }

            this.setConversationAsRead(user_id).then(() => {
                return this.loadConversation(user_id);
            }).then((reversed) => {
                const user = this.users[this.showing];
                Vue.set(user, 'messages', reversed);
                Vue.set(user, 'messagesLoaded', true);
                let ts = this.lastTimestamp;
                for (let m = 0; m < reversed.length; m++) {
                    if (ts < reversed[m].sent_at) ts = reversed[m].sent_at;
                }
                this.lastTimestamp = ts;
                this.updateReads();
                openChat();
            }).catch(err => console.log(err));
        },

        beep(beep) {
            if (!beep) {
                return false;
            }
            let url = 'https://fox.app.br/layouts/default/mp3/beep-1.mp3';
            $('#msgBeep').attr('src', url);
            let sound = document.getElementById("msgBeep");
            sound.play();
            // Notification
            /*
            var addNotification = document.getElementById("add_notification");
            addNotification.addEventListener("click", function (event) {
                Notification.requestPermission().then(function (permission) {
                    if (permission === "granted") {
                        var options = {
                            body: 'Você possui novas mensagens',
                            timestamp: new moment()
                        }
                        new Notification('Mensagens', options);
                    }
                });
            })*/
        },

        open() {
            this.screen = 'users';
        },

        back() {
            this.screen = 'users';
        },

        close() {
            this.screen = 'users';
        },

        toggleFullScreen() {
            if ((document.fullScreenElement && document.fullScreenElement !== null) ||
                (!document.mozFullScreen && !document.webkitIsFullScreen)) {
                if (document.documentElement.requestFullScreen) {
                    document.documentElement.requestFullScreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullScreen) {
                    document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        }

    },

    filters: {
        integer(value) {
            if (value === null) {
                return '-';
            }
            let places = 6;
            let zero = places - value.toString().length + 1;
            let string = Array(+(zero > 0 && zero)).join("0") + value;
            return string.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        decimal(value) {
            return (value) ? parseFloat(value).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g,
                ".") : '';
        },
        date(value) {
            return (value) ? moment(value).format('DD/MM/YYYY') : '-';
        },
        datetime(value) {
            return (value) ? moment(value).format('DD/MM/YYYY HH:mm') : '-';
        },
        time(value) {
            return (value) ? moment.unix(value).format('HH:mm') : '-';
        },
        quantidade(value, step) {
            if (step == 1) {
                return parseFloat(value).toFixed(0).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            }
            return parseFloat(value).toFixed(3).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        cnpj(value) {
            return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
        }
    }

}
</script>
